import * as React from "react";
import MuiMenuItem, {
    MenuItemProps as MuiMenuItemProps,
    MenuItemClassKey as MuiMenuItemClassKey
} from "@material-ui/core/MenuItem";


export type MenuItemClassKey = MuiMenuItemClassKey;

export interface MenuItemProps extends MuiMenuItemProps { }

class MenuItem extends React.PureComponent<MenuItemProps> {
    render() {
        const { ...props } = this.props;
        return <MuiMenuItem {...props}>
            {this.props.children}
        </MuiMenuItem>;
    }
}

export default MenuItem;